module.exports = __webpack_public_path__ + "img/barra-azul-blanco.9c330e7e.svg";